<template>
  <div>
    <div class="sms-center-container">
      <div class="side-bar">
        <div class="header" @click="newMessage">
          <svg class="svg-white" width="30px" height="30px" viewBox="0 0 30 30" version="1.1">
            <path
              d="M14.9776692,5 C9.47601504,5 5,9.47593985 5,14.977594 C5,20.4792481 9.47593985,24.955188 14.977594,24.955188 C20.4792481,24.955188 24.9551128,20.4792481 24.9551128,14.977594 C24.9551128,9.47593985 20.4793233,5 14.9776692,5 Z M14.9776692,23.8273684 C10.0978195,23.8273684 6.12781955,19.8574436 6.12781955,14.977594 C6.12781955,10.0977444 10.0978195,6.12781955 14.9776692,6.12781955 C19.8573684,6.12781955 23.8273684,10.0978195 23.8273684,14.977594 C23.8273684,19.8573684 19.8573684,23.8273684 14.9776692,23.8273684 Z M18.4926901,14.3550877 L15.7499108,14.3550877 L15.7499108,11.6578947 C15.7499108,11.2944737 15.4504601,11 15.0808967,11 C14.7113333,11 14.4118826,11.2944737 14.4118826,11.6578947 L14.4118826,14.3550877 L11.6690141,14.3550877 C11.2994507,14.3550877 11,14.6495614 11,15.0129825 C11,15.3764035 11.2994507,15.6708772 11.6690141,15.6708772 L14.4117934,15.6708772 L14.4117934,18.3681579 C14.4117934,18.7315789 14.7112441,19.0260526 15.0808075,19.0260526 C15.4503709,19.0260526 15.7498216,18.7315789 15.7498216,18.3681579 L15.7498216,15.6708772 L18.4926009,15.6708772 C18.8621643,15.6708772 19.161615,15.3764035 19.161615,15.0129825 C19.161615,14.6495614 18.8621643,14.3550877 18.4926901,14.3550877 Z"
              id="path-1"
            />
          </svg>
          <p>New Message</p>
        </div>
        <div class="body">
          <recipient-component
            @click.native="() => openChat(recipient)"
            :index="activeRecipient.recipient_uuid ? activeRecipient.recipient_uuid : ''"
            v-for="(recipient, k) in smsReport"
            :key="k"
            :recipient="recipient"
            :lastSms="smsList ? smsList[0] : null"
            :uuid="recipient.recipient_uuid"
          />
        </div>
      </div>

      <div class="chat-container">
        <div class="header">
          <header-component v-if="!isNewMessage && !is_welcome" :user_info="activeRecipient" />

          <!-- <dropdown-component 
            v-if="isNewMessage"
            id="dropdown"
            :options="options"
            v-on:selected="validateSelection"
            placeholder="Type a name"> 
          </dropdown-component>-->

          <div v-if="isNewMessage" class="search-container">
            <multiselect
              placeholder
              label="title"
              track-by="title"
              @select="selectedRecipient"
              @search-change="handleSearchInput"
              :options="options"
              :option-height="104"
              :custom-label="customLabel"
              :show-labels="false"
            >
              <template slot="singleLabel" slot-scope="props">
                <img class="option__image" :src="props.option.img" alt />
                <span class="option__desc">
                  <span class="option__title">{{ props.option.title }}</span>
                </span>
              </template>
              <template slot="option" slot-scope="props">
                <img class="option__image" v-if="props.option.img" :src="props.option.img" alt />
                <img class="option__image" v-else alt />
                <div class="option__desc">
                  <span class="option__title">{{ props.option.title }}</span>
                  <span class="option__small">{{ props.option.phone }}</span>
                </div>
              </template>
            </multiselect>
          </div>
        </div>

        <div class="body">
          <welcome
            v-if="is_welcome && !isNewMessage"
            :current_user_name="current_user_name"
            :unreadCount="unreadCount"
          />

          <sms-list
            v-if="!isNewMessage && !is_welcome"
            :user_info="activeRecipient"
            :infiniteId="infiniteId"
            :page="smsPage"
            @addpage="updatePage"
          />
        </div>

        <div class="footer">
          <message-box
            v-if="!isNewMessage && !is_welcome"
            :user_info="activeRecipient"
            @changeInfiniteId="updateInfiniteId"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { format } from "date-fns";
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    RecipientComponent: () =>
      import("../../../components/SmscCenter/Recipient.vue"),
    DropdownComponent: () => import("vue-simple-search-dropdown"),
    HeaderComponent: () => import("./Header"),
    MessageBox: () => import("./MessageBox"),
    Welcome: () => import("./Welcome"),
    SmsList: () => import("./SmsList"),
  },
  data: () => ({
    value: { title: null, desc: null, img: null, id: null, phone: null },
    options: [],
    selected: { name: null, id: null },
    allRecipients: null,
    recipients: [],
    isNewMessage: false,
    newRecipientId: null,
    cancelled: false,
    current_user_logo: null,
    current_user_name: null,
    page: 0,
    loaded: false,
    fromChild: 0,
    is_input: true,
    is_welcome: true,
    infiniteId: +new Date(),
    smsPage: 0,
  }),
  computed: {
    ...mapGetters({
      smsList: "smses/getSmsList",
      smsReportList: "smses/getSmsRecipientReport",
      activeRecipient: "smses/getActiveRecipient",
      unreadCount: "smses/getUnreadCount",
    }),
    smsReport() {
      console.log("this.smsReportList", this.smsReportList);
      const res = this.smsReportList.filter(
        (i) => i.recipient_uuid !== null || i.recipient_number !== null
      );
      console.log("res", res);
      return res;
    },
    currentUserUuid() {
      return this.$store.state.user.user.user_id;
    },
    reportRecipientIds() {
      return this.smsReport.map((i) => i.recipient_uuid);
    },
  },
  watch: {
    recipients() {
      return this.recipients;
    },
  },
  created() {
    this.GetList("");

    // this.cancelled = true

    this.current_user_name = this.$store.state.user.user.last_name;
    this.current_user_logo = this.$store.state.user.user.logo_file_uuid
      ? `http://88.198.219.62/api_smsc/v1/file/${this.$store.state.user.user.logo_file_uuid}`
      : "";
  },
  methods: {
    ...mapActions({
      viewSmses: "smses/getSmsList",
      viewSmsReport: "smses/getSmsRecipientReport",
      updateSmsReport: "smses/updateSmsRecipientReport",
      changeActiveRecipient: "smses/updateActiveRecipient",
      changeUreadCount: "smses/updateUreadCount",
      resetSmsState: "smses/resetSmsState",
    }),
    customLabel({ title, phone }) {
      return `${title} – ${phone}`;
    },
    handleSearchInput(value) {
      this.value = value;

      if (value.length >= 10 && value.length <= 15 && value.match(/^[0-9]+$/)) {
        this.options.push({
          title: null,
          desc: null,
          img: null,
          id: null,
          phone: value,
        });
      }
    },
    updatePage() {
      this.smsPage++;
    },
    updateInfiniteId() {
      this.smsPage = 0;
      this.infiniteId++;
    },
    async getRecipientsList() {
      const { items } = await this.$store.dispatch("GetRecipientList", {});
      this.allRecipients = items;
    },
    createFile(file) {
      if (!file.type.match("image.*")) {
        alert("Select an image");
        return;
      }
      var img = new Image();
      var reader = new FileReader();
      var vm = this;

      reader.onloadend = function () {
        img.src = reader.result;
      };
      reader.readAsDataURL(file);
    },
    // selectedValue(selection){
    //   console.log("selection", selection)
    //    this.validateSelection(selection)
    // },
    newMessage() {
      this.isNewMessage = true;
    },
    selectedRecipient: async function (selection) {
      if (selection.phone && !selection.id) {
        this.isNewMessage = false;
        const recipient = {
          recipient_name: null,
          recipient_uuid: null,
          recipient_number: selection.phone,
          sms_count: 0,
        };

        await this.updateSmsReport(recipient);
        this.options = this.options.filter(
          (item) => item.phone !== selection.phone
        );

        await this.changeActiveRecipient(recipient);

        return;
      }
      this.newRecipientId = selection.id;

      console.log("validateSelection", selection);

      this.is_welcome = false;
      if (selection.id) {
        this.isNewMessage = false;
      }

      if (this.newRecipientId) {
        const res = await this.$store.dispatch(
          "GetRecipient",
          this.newRecipientId
        );
        const {
          recipient_name,
          recipient_uuid,
          phone_number: recipient_number,
        } = res;
        this.recipients.push(res);
        const recipient = {
          recipient_name,
          recipient_uuid,
          recipient_number,
          sms_count: 0,
        };

        await this.updateSmsReport(recipient);
        this.options = this.options.filter(
          (item) => item.id !== this.newRecipientId
        );

        await this.changeActiveRecipient(recipient);
      }
    },
    getDropdownValues(keyword) {
      console.log("keyword", keyword);
    },
    async GetList(currenUserInfo, from) {
      await this.viewSmsReport();

      await this.getRecipientsList();

      this.recipients = [];
      this.options = [];

      // this.allRecipients.map(i => {
      //   if (this.newRecipientId && this.newRecipientId == i.recipient_uuid) {
      //     this.recipients.push(i);
      //   }
      //   if(this.smsReport.indexOf(i.recipient_uuid)>= 0){
      //     this.recipients.push(i);
      //   } else {
      //     // this.options.push({ id: i.recipient_uuid, name: i.recipient_name });
      //     this.options.push({ title: i.recipient_name, desc: '', img: null, id: i.recipient_uuid, phone: i.phone_number })
      //   }

      // });

      this.allRecipients.map((i) => {
        if (this.reportRecipientIds.indexOf(i.recipient_uuid) >= 0) {
          this.recipients.push(i);
        } else {
          this.options.push({
            title: i.recipient_name,
            desc: "",
            img: null,
            id: i.recipient_uuid,
            phone: i.phone_number,
          });
        }
      });
    },
    async getSmsList() {
      if (this.activeRecipient) {
        await this.viewSmses({
          recipient_uuid: this.activeRecipient.recipient_uuid,
          page: 0,
        });
      }
    },
    getOptions() {
      this.options = this.allRecipients.map((i) => {
        return { id: i.recipient_uuid, name: i.recipient_name };
      });
    },
    makeSmsRead(id) {
      // this.$store.dispatch("EditSms", { id, sms: { is_read: 'true' } }).then(res => {
      //   console.log("res from makeReadddd-->", res)
      // })
    },
    openChat(recipient) {
      this.is_welcome = false;
      this.isNewMessage = false;

      this.changeActiveRecipient(recipient);
      this.infiniteId++;
      this.smsPage = 0;
      this.getSmsList();
      this.page = 0;
    },
  },
  beforeRouteLeave(to, from, next) {
    // const answer = window.confirm('Do you really want to leave? you have unsaved changes!')
    // if (answer) {
    //   next()
    // } else {
    //   next(false)
    // }
    this.resetSmsState();
    next();
  },
};
</script>

<style lang="scss">
.default {
  border-radius: 50%;
  border: 1px solid lightgrey;
}
.sms-center-container {
  padding: 20px;
  display: flex;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  .side-bar {
    width: 300.21px;
    min-width: 300.21px;
    height: calc(100% - 40px);
    background-color: #ffffff;
    .header {
      height: 60px;
      width: 100%;
      border-radius: 4px 0 0 0;
      background-color: #51a3f3;
      border-bottom: 1px solid #51a3f3;
      border-right: 1px solid #51a3f3;
      display: flex;
      align-items: center;
      color: #ffffff;
      font-family: "Helvetica Neue";
      font-size: 16px;
      line-height: 25px;
      .svg-white {
        margin-left: 20px;
        fill: #fff;
      }
      p {
        margin-left: 5px;
        margin-bottom: 0;
      }
    }
    .body {
      height: calc(100% - 60px);
      overflow: auto;
      min-height: 460px;
      .recipient-item {
        background: #f0f1fa;
      }
    }
    ::-webkit-scrollbar {
      display: none;
    }
  }
  .chat-container {
    border-radius: 0 4px 0 0;
    background-color: #ffffff;
    border-left: 1px solid #f0f1fa;
    height: calc(100% - 40px);
    width: 100%;
    .avatar {
      height: 30px;
      width: 30px;
      margin-right: 8px;
      border-radius: 50%;
      vertical-align: middle;
      object-fit: cover;
    }
    .header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 60px;
      width: 100%;
      padding: 15px;
      box-sizing: border-box;
      border-radius: 0 4px 0 0;
      border-bottom: 1px solid #f0f1fa;
      display: flex;
      align-items: center;
      color: #ffffff;
      font-family: "Helvetica Neue";
      font-size: 14px;
      line-height: 25px;
      .user-info {
        display: flex;
        align-items: center;
        p {
          color: #55616e;
          margin-bottom: 0;
          font-size: 16px;
        }
        .user-name {
          color: #000000;
          font-family: "Helvetica Neue";
          font-size: 14px;
          line-height: 25px;
          margin-bottom: 0;
        }
        .phone-number {
          font-family: "Helvetica Neue";
          font-size: 14px;
          line-height: 25px;
          margin-bottom: 0;
        }
        .svg-gray {
          cursor: pointer;
          margin-left: 15px;
          fill: #55616e;
        }
      }
      .search-container {
        width: 450px;
        .multiselect__option {
          display: flex;
          .option__image {
            height: 30px;
            width: 30px;
            border-radius: 50%;
            margin-right: 8px;
          }
          .option__desc {
            margin-top: 6px;
            .option__title {
              margin-right: 5px;
            }
            .option__small {
              color: #55616e;
            }
          }
        }
        .multiselect__option--highlight {
          background-color: #eceef0;
          color: #000000;
        }
      }
    }
    .body {
      padding: 15px 15px 15px 15px;
      box-sizing: border-box;
      // height: calc(100% - 120px);

      //display: flex;

      // flex-direction: row;
      // flex-wrap: nowrap;
      // justify-content: flex-end;
      // align-content: flex-start;
      // align-items: flex-end;
      height: 400px;
      overflow-y: scroll;
      .unread_container {
        height: 100%;
        width: 100%;
        position: relative;
        .unread {
          margin-top: 30px;
          font-size: 16px;
          font-weight: 500;
          color: #000000;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
        .user_name {
          font-size: 24px;
          font-weight: 700;
          color: #000000;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }
    }
    ::-webkit-scrollbar {
      display: none;
    }
    .footer {
      height: 60px;
      width: 100%;
      display: flex;
      justify-content: space-between;
      border-radius: 0 0 4px 0;
      background-color: #ffffff;
      box-shadow: inset 0 1px 0 0 #f0f1fa;
      padding: 15px 15px 15px 15px;
      box-sizing: border-box;
      .svg-gray {
        cursor: pointer;
        margin-left: 15px;
        fill: #55616e;
      }
      .svg-gray:first-child {
        margin-left: 0;
      }
      .upload-photo,
      #dropzone {
        // margin-left: 15px;
        border: none;
        width: 30px;
        //min-height: 60px !important;
        height: 30px;
        color: #55616e;
        font-family: "Helvetica Neue";
        font-size: 14px;
        line-height: 25px;
        padding: 0;
        .dz-image {
          //padding: 5px;
          img {
            height: 30px;
            width: 30px;
            border-radius: 50px;
          }
        }
        .dz-message {
          margin: 0;
        }
      }
      .vue-dropzone {
        min-height: 30px;
        margin-right: 0;
      }
      input {
        margin-left: 15px;
        border: none;
        width: 100%;
        height: 100%;
        color: #55616e;
        font-family: "Helvetica Neue";
        font-size: 14px;
        line-height: 25px;
      }
    }
  }
}
</style>

